/* ==========================================================================
   BLORËM — comportements DA
   ========================================================================== */

/* --- 1. Apparition au scroll -------------------------------------------
   Fade-up discret, une section à la fois. Ne masque rien si
   l'IntersectionObserver est absent, si l'utilisateur a demandé moins
   d'animations, ou si la section est déjà visible au chargement (sinon on
   provoque un flash blanc au-dessus de la ligne de flottaison). */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var sections = document.querySelectorAll('.shopify-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('bl-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );

    var viewportHeight = window.innerHeight;
    sections.forEach(function (section) {
      if (section.getBoundingClientRect().top < viewportHeight * 0.9) return;
      section.classList.add('bl-reveal');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --- 2. Carrousel d'avis : glissement souple sur mobile -----------------
   Historique : le drag par défaut de Splide fonctionne à la souris mais
   reste capricieux au doigt (le geste démarre puis revient sur la carte
   courante). Une première tentative — désactiver Splide pour rendre la
   main au défilement natif — cassait la section et a été annulée.

   Ici on garde Splide et on se contente d'assouplir le geste :
   drag:'free' supprime le seuil à franchir, snap:true réaligne sur une
   carte au relâchement. Les flèches restent, quoi qu'il arrive.

   ⚠️ Uniquement sous 750px : réassigner les options fait perdre les
   breakpoints du thème (vérifié — le desktop repassait à ~1 carte par
   page au lieu de 3). Sous 750px aucun breakpoint n'est actif, donc leur
   perte est sans effet. */
(function () {
  /* Carrousel d'avis : le block `slider` (Splide) a été remplacé par un rail
     à défilement natif. Cf. D-046 : trois tentatives pour faire fonctionner le
     drag Splide au doigt ont échoué, la dernière cassait la section. Le
     défilement natif du navigateur, lui, marche partout sans qu'on l'aide.

     Il ne reste qu'à recréer les flèches, que Splide fournissait. Elles sont
     injectées ici plutôt qu'ajoutées au template : ce sont des contrôles
     d'interface, pas du contenu à éditer. */

  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';

  function build() {
    var section = document.querySelector('.blorem-avis');
    if (!section) return true;

    var rail = section.querySelector('.rev-rail');
    if (!rail) return false;
    if (rail.dataset.blNav) return true;

    var nav = document.createElement('div');
    nav.className = 'rev-nav';

    function arrow(direction, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', label);
      b.innerHTML = ARROW;
      if (direction > 0) b.style.transform = 'scaleX(-1)';
      b.addEventListener('click', function () {
        var card = rail.querySelector('.rev-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(rail).gap) || 16;
        rail.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: 'smooth',
        });
      });
      return b;
    }

    nav.appendChild(arrow(-1, 'Avis précédent'));
    nav.appendChild(arrow(1, 'Avis suivant'));
    rail.parentNode.insertBefore(nav, rail.nextSibling);
    rail.dataset.blNav = '1';
    return true;
  }

  function start() {
    if (build()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (build() || ++tries > 25) clearInterval(timer);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   FAQ de la page « La formule » : une seule question ouverte à la fois.
   Le custom element `accordion-row` du thème ne gère que l'état initial
   selon la media query (assets/accordion.js), il n'y a aucune animation
   à préserver : basculer `open` en JS est sans effet de bord.
   Ciblé sur .blorem-formule-faq, pour ne pas changer la FAQ à onglets
   de la page produit.
   ========================================================================== */
(function () {
  function start() {
    var groups = document.querySelectorAll('.blorem-formule-faq .accordions');
    for (var g = 0; g < groups.length; g++) {
      (function (group) {
        var items = group.querySelectorAll('details.accordion');
        for (var i = 0; i < items.length; i++) {
          items[i].addEventListener('toggle', function () {
            if (!this.open) return;
            for (var j = 0; j < items.length; j++) {
              if (items[j] !== this && items[j].open) items[j].open = false;
            }
          });
        }
      })(groups[g]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
